<template>
	<div
		ref="nodeFlyoutContainer"
		class="flyout-container"
	>
		<div class="flyout">
			<div
				class="flyout__instructions"
				v-html="text"
			/>
			<div class="flyout__colors">
				<CircleColorBtn
					v-for="color in props.colorData"
					:key="color.id"
					:label="color.title"
					:image="color.thumb_url"
					@click="emit( 'select:color', color.id )"
				/>
			</div>

			<button
				class="flyout__close"
				@click="emit( 'close:flyout' )"
			>
				&times;
			</button>
		</div>
	</div>
</template>


<style lang="scss">
html.is-fixed {
	overflow-y: hidden;
}

.flyout-container {
	position: fixed;
	top: 0;
	left: 0;
	display: flex;
	place-content: center;
	place-items: center;
	width: 100%;
	height: 100%;
	padding: 24px;
	background-color: rgba( 0, 0, 0, .75 );
	z-index: 1000000;

	@media( min-width: 768px ) {
		padding: 48px;
	}
}

.flyout {
	position: relative;
	width: 100%;
	max-height: 100%;
	padding: 48px 24px 24px;
	background-color: white;
	// border-radius: 12px;
	overflow-y: scroll;

	@media( min-width: 768px ) {
		padding: 64px 48px 48px;
	}

	&__instructions {
		margin-bottom: 36px;
		font-weight: bold;
		text-align: center;
		border-bottom: 1px solid #E9E9E9;

		& > p {
			font-size: 24px;
		}
	}

	&__colors {
		display: grid;
		grid-template-columns: repeat( auto-fill, minmax( 70px,1fr ) );
		gap: 16px;
		place-content: center;

		.circle-color {
			flex-basis: 120px;
		}

		@media( min-width: 768px ) {
			grid-template-columns: repeat( auto-fill, minmax( 120px,1fr ) );
			gap: 32px;
		}
	}

	&__close {
		position: absolute;
		top: 16px;
		right: 16px;
		display: flex;
		place-items: center;
		place-content: center;
		width: 36px;
		height: 36px;
		padding: 0;
		font-size: 24px;
		color: white;
		background-color: #CF3339;
		z-index: 1000;
		transition: linear 0.175s;
		border: none;
		border-radius: 50%;

		&:hover {
			background-color: #B52B30;
		}
	}
}
</style>


<script setup>
import { onBeforeUnmount, onMounted, ref } from 'vue'
import CircleColorBtn from './CircleColorBtn.vue'


const props = defineProps({
	colorData: {
		type: Array,
		required: true,
	},
	text: {
		type: String,
		default: '',
	},
})


const emit = defineEmits(
	[
		'select:color',
		'close:flyout',
	],
)


const nodeFlyoutContainer = ref( null )


/**
 * Close flyout if user clicks "escape"
 *
 * @param {event} e
 * @return {void}
 */
const handleKeyPress = e => {
	if ( 'Escape' === e.key ) {
		emit( 'close:flyout' )
	}
}


/**
 * Close flyout if user clicks outside of flyout
 *
 * @param {event} e
 * @return {void}
 */
const handleClick = e => {
	const { target } = e

	if ( target.classList.contains( 'flyout-container' ) ) {
		emit( 'close:flyout' )
	}
}


onMounted( () => {
	document.querySelector( 'html' ).classList.add( 'is-fixed' )

	document.addEventListener( 'click', handleClick )

	document.addEventListener( 'keydown', handleKeyPress, {
		once: true,
	})
})


onBeforeUnmount( () => {
	document.querySelector( 'html' ).classList.remove( 'is-fixed' )

	document.removeEventListener( 'click', handleClick )

	document.removeEventListener( 'keydown', handleKeyPress )
})

</script>
